import type { CultureExperienceTypeDTO } from '@ui/shared/util-api';
import { type ExperienceType, ExperienceTypeModel } from '../entities/experience-type.model';

export class CulturalExperienceTypeMapper {
    public static fromDto(dto: CultureExperienceTypeDTO): ExperienceType {
        return new ExperienceTypeModel({
            id: dto.id,
            label: dto.name,
        });
    }
}
